// ** React Imports
import { useEffect } from "react";

// ** Third Party Components
import { useTranslation } from "react-i18next";

// ** Custom Components
import Block from "components/layout/Block";
import TextField from "components/layout/TextField";

// #####################################################

const SearchInput = ({
	searchValue,
	setSearchValue,
	isLocationAutocomplete = false,
	isLanding = false,
	customPadding = false,
	isOpen,
	searchInputRef,
}) => {
	const { t } = useTranslation(["pages"]);

	useEffect(() => {
		if (
			isOpen &&
			searchInputRef.current &&
			document.activeElement !== searchInputRef.current
		) {
			searchInputRef.current.focus({ preventScroll: true });
		}
	}, [isOpen]);

	// #####################################################

	return (
		<Block
			style={{
				padding: customPadding || "0.75rem 1rem 0 1rem",
			}}
		>
			<TextField
				ref={searchInputRef}
				value={searchValue}
				onChange={(event) =>
					isLocationAutocomplete
						? setSearchValue(event)
						: setSearchValue(event.target.value)
				}
				label={t("pages:search")}
				placeholder={t("pages:search")}
				$addHeight
				$isLanding={isLanding}
				$shadowBottom
				$bold
			/>
		</Block>
	);
};

// #####################################################

export default SearchInput;

// #####################################################
